import { createFileRoute } from '@tanstack/react-router';
import LanesView from '../terminal/LanesView';
export const Route = createFileRoute('/terminals/lanes')({ component: LanesView });
